import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//@ts-ignore
import {
  PermissionRequired,
  AccessControl,
} from "@careinfo/permission-required";
import ReturnBranchList from "../pages/ReturnBranch/ReturnBranchList";
import CreateReturnBranch from "../pages/ReturnBranch/CreateReturnBranch";
import EditReturnBranch from "../pages/ReturnBranch/EditReturnBranch";

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route
            path="/"
            element={
              <AccessControl
                children={<ReturnBranchList />}
                allowedPermissions={["can_view_rtv_return"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/create"
            element={
              <AccessControl
                children={<CreateReturnBranch />}
                allowedPermissions={["can_create_rtv_return"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/edit/:id"
            element={
              <AccessControl
                children={<EditReturnBranch />}
                allowedPermissions={["can_view_rtv_return"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
